'use strict';
/* global pageContext */

var dataLayer = window.dataLayer;

/**
 * @param {Object} productObject The product data
 * @description gets the data for a product click
 */
function productClick(productObject) {
    var obj = {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @param {Object} productObject The product data
 * @description gets the data for a wishlist click
 */
function wishlistClick(productObject) {
    var obj = {
        event: 'wishlistClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @param {Object} productObject The product data
 * @description gets the data for product compare click
 */
function compareClick(productObject) {
    var obj = {
        event: 'compareClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @description Click event for add product to cart
 * @param {Object} productObject The product data
 * @param {string} quantity product quantity
 * @param {string} selectedCustomizationValue product option
 */
function addToCart(productObject, quantity, selectedCustomizationValue) {
    var selectedCustomization = 'Not Applicable';
    if (selectedCustomizationValue && selectedCustomizationValue.length > 0) {
        selectedCustomization = 'No Customization Added';
        if (selectedCustomizationValue === 'custom') {
            selectedCustomization = 'Full Custom';
        }
        if (selectedCustomizationValue === 'engraved') {
            selectedCustomization = 'Engraved';
        }
        if (selectedCustomizationValue === 'embroidered') {
            selectedCustomization = 'Embroidered';
        }
        if (selectedCustomizationValue === 'embroidered') {
            selectedCustomization = 'Embroidered';
        }
    }
    productObject.dimension6 = selectedCustomization;

    var quantityObj = {
        quantity: quantity
    };

    var obj = {
        event: 'addToCart',
        ecommerce: {
            currencyCode: $('[data-currency-code]').data('currency-code') || 'USD',
            add: {
                products: []
            }
        }
    };
    obj.ecommerce.add.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}

/**
 *
 * @param {Object} productObject product object
 * @param {string|number} quantity product quantity
 */
function removeFromCart(productObject, quantity) {
    var quantityObj = {
        quantity: quantity
    };

    var obj = {
        event: 'removeFromCart',
        ecommerce: {
            currencyCode: $('[data-currency-code]').data('currency-code') || 'USD',
            remove: {
                products: []
            }
        }
    };

    obj.ecommerce.remove.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}

/**
 * Updates the current step in the checkout flow
 * @param {Integer} step the step number the flow is currently on
 */
function updateCheckoutStep(step) {
    var obj = {
        event: 'checkout',
        ecommerce: {
            currencyCode: '',
            checkout: {
                actionField: {
                    step: step
                }
            }
        }
    };
    var currencyCode = $('[data-currency-code]').data('currency-code') || 'USD';

    /* eslint-disable */
    if (step === 2) {
        var productsContainer = $('.order-product-summary .product-summary-block');
        obj.ecommerce.checkout.products = [];
        obj.ecommerce.currencyCode = currencyCode;
        productsContainer.find('.product-line-item').each(function () {
            var product = $.parseJSON($(this).attr('data-gtmdata'));
            var quantity = $(this).find('.qty-card-quantity-count').text();
            product.quantity = quantity;
            obj.ecommerce.checkout.products.push(product);
        });
    }

    if (step === 3 || step === 4) {
        var selectedShippingMethod = $('.shipping-method-list input[name="dwfrm_shipping_shippingAddress_shippingMethodID"]:checked').first(1);
        var shippingOption = selectedShippingMethod.siblings('.shipping-method-option').find('.display-name').text();
        var productsContainer = $('.order-product-summary .product-summary-block');
        obj.ecommerce.checkout.products = [];
        obj.ecommerce.currencyCode = currencyCode;
        obj.shippingOption = shippingOption;
        productsContainer.find('.product-line-item').each(function () {
            var product = $.parseJSON($(this).attr('data-gtmdata'));
            var quantity = $(this).find('.qty-card-quantity-count').text();
            product.quantity = quantity;
            obj.ecommerce.checkout.products.push(product);
        });
    }
    /* eslint-enable */

    dataLayer.push(obj);
}

/**
 * @description Convenience method for creating a click event.
 * @param {string} event event
 * @param {string} eventCategory event categroy
 * @param {string} eventAction event action
 * @param {string} eventLabel event layer
 */
function pushEvent(event, eventCategory, eventAction, eventLabel) {
    dataLayer.push({
        event: event,
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel
    });
}

/**
 * @description Convenience method for creating a click event.
 * @param {string} event event
 * @param {string} navItemType event categroy
 * @param {string} eventLabel event layer
 */
function pushNavEvent(event, navItemType, eventLabel) {
    dataLayer.push({
        event: event,
        navItemType: navItemType,
        navItem: eventLabel
    });
}

/**
 * @description Convenience method for creating a click event.
 * @param {string} event event
 * @param {string} refinement refinement
 */
function pushRefinementEvent(event, refinement) {
    dataLayer.push({
        event: event,
        refinement: refinement
    });
}

/**
 * Email List Signup Event
 * @param {string} signupLocation Sign up Location - Footer or Account Creation
 */
function emailSignup(signupLocation) {
    var subscribeObj = {
        event: 'emailSignup',
        hostSite: pageContext.host || $('.logo-home.active').data('gtmdata'),
        signupLocation: signupLocation
    };
    dataLayer.push(subscribeObj);
}


/**
 * @param {Object} productObject The product data
 * @description gets the data for a product click
 */
function productTileClick(productObject) {
    dataLayer.push(productObject);
}

var events = {
    account: function () { },
    login: function () {
        $('form.registration').on('login:register:success', function () {
            var obj = {
                event: 'createAccount',
                hostSite: pageContext.host
            };
            dataLayer.push(obj);
            // If any of add to email list checkboxes is checked - Subscribed
            // if ($("input[id^='add-to-email-list']:checked").length > 0) {
            //     emailSignup('Account Creation');
            // }
        });
    },
    cart: function () {
        $('.cart.cart-page .remove-product').on('click', function () {
            var gtmData = $(this).attr('data-gtmdata');
            $('.cart-delete-confirmation-btn').on('click', function () {
                removeFromCart($.parseJSON(gtmData), 1);
            });
        });
    },
    checkout: function () {
        // step 1 is cart page - data pushed to layer with page rendering
        // step 2 is shipping page - data pushed to layer with page rendering
        // step 5 is order confirmation page - data pushed to layer with page rendering

        // step 3 is payment
        $('button.next-payment').on('click', function () {
            updateCheckoutStep(3);
        });

        // step 4 is review
        $('button.submit-payment').on('click', function () {
            updateCheckoutStep(4);
        });

        // Edit/Back buttons
        $('#editShipping').on('click', function () {
            updateCheckoutStep(2);
        });
        $('#editPayment').on('click', function () {
            updateCheckoutStep(3);
        });
    },
    compare: function () {
        $('.wishlistTile').on('click', function () {
            wishlistClick($.parseJSON($(this).attr('data-gtmdata')));
        });
    },
    product: function () {
        $('.add-to-cart').on('click', function () {
            var selectedCustomizationValue = $('.data-column select.options-select option:selected').data('value-id');
            addToCart($.parseJSON($(this).attr('data-gtmdata')), $('.quantity-select').val(), selectedCustomizationValue);
        });
        // PDP pageload event
        dataLayer.push(pageContext.productObject);
    },
    search: function () {
        $('.quickview').on('click', function () {
            productClick($.parseJSON($(this).attr('data-gtmdata')));
        });
        $('.wishlistTile').on('click', function () {
            wishlistClick($.parseJSON($(this).attr('data-gtmdata')));
        });
        $('.compare input[type=checkbox]').on('click', function () {
            var checked = $(this).is(':checked');
            if (checked) {
                compareClick($.parseJSON($(this).attr('data-gtmdata')));
            }
        });
        $('.product-tile').on('click', function () {
            productTileClick($.parseJSON($(this).attr('data-gtmdata')));
        });
    },
    storefront: function () { },
    wishlist: function () { },
    // events that should happen on every page
    all: function () {
        var prevNav = null;
        $('.pdp-link .link').on('click', function () {
            productClick($(this).data('gtmdata'));
        });
        $('.nav-link.dropdown-toggle').on('click', function () {
            prevNav = $(this).text().trim();
            pushNavEvent('navEngagement', 'Text', $(this).text().trim());
        });
        $('.linkbuilder-text_link.dropdown-link.bold').on('click', function () {
            pushNavEvent('navEngagement', 'Text', prevNav + ' - ' + $(this).text().trim());
        });
        $('.linkbuilder-text_link.dropdown-link.Default').on('click', function () {
            pushNavEvent('navEngagement', 'Text', prevNav + ' - ' + $(this).text().trim());
        });
        // Mega Menu Banner Image
        $('.pd-megamenu .experience-banners picture a').on('click', function () {
            pushNavEvent('navEngagement', 'Image', prevNav + ' - Mega Menu Banner');
        });
        // Mega Menu Banner Text
        $('.pd-megamenu .experience-banners .copyblock-text_link').on('click', function () {
            pushNavEvent('navEngagement', 'Text', prevNav + ' - Mega Menu Banner Text');
        });
        $('.custom-icon').on('click', function () {
            pushNavEvent('navEngagement', 'Image', $(this).text().trim());
        });
        $('.d-none.d-md-block').on('click', function () {
            pushRefinementEvent('catRefinement', $(this).text().trim());
        });
        $('.ref-button').on('click', function () {
            pushRefinementEvent('catRefinement', $(this).text().trim());
        });
        $('.ref-button-circle').on('click', function () {
            pushRefinementEvent('catRefinement', $(this).text()).trim();
        });
        $('.navbar-header.brand').on('click', function () {
            pushEvent('trackEvent', 'User Action', 'Header Click', 'Home Link');
        });
        $('.minicart').on('mouseenter focusin touchstart', function () {
            $('.minicart .remove-product').on('click', function () {
                var gtmData = $(this).attr('data-gtmdata');
                $('.cart-delete-confirmation-btn').on('click', function () {
                    removeFromCart($.parseJSON(gtmData), 1);
                });
            });
        });

        // Footer Subscribe Email box signup
        $('.subscribe-email').on('subscribe:email:success', function () {
            emailSignup('Footer');
        });

        // Email Opt in signup
        $('form.emailoptin-form').on('modal-optin:email:success', function () {
            emailSignup('Opt-in modal');
        });

        // Header Brand Logo Click
        $('.logo-home').on('click', function () {
            var logoObj = {
                event: 'tabClick',
                destination: $(this).attr('data-gtmdata')
            };
            dataLayer.push(logoObj);
        });

        // Every product tile click in content carousels
        $('body').on('click', '.product-tile a', function () {
            if (window.gtmClickTileUrl) {
                let elementName;
                let $component = $(this).parents('.experience-component').first();
                let $slot = $(this).parents('.recommendations').first();

                if ($component.length > 0 || $slot.length > 0) {
                    if ($component.length > 0) {
                        elementName = $component.find("[class$='headline']").text();
                    }

                    if (!elementName && $slot.length > 0) {
                        elementName = $slot.find('h3').text();
                        elementName = elementName || $slot.find('h4').text();
                    }
                    elementName = elementName || 'Recommendations';
                    $.ajax({
                        url: window.gtmClickTileUrl,
                        type: 'GET',
                        data: { elementName: elementName }
                    });
                }
            }
        });
    },

    orderconfirmation: function () {
        $('form.checkout-registration').on('checkout:register:success', function () {
            var obj = {
                event: 'createAccount',
                hostSite: pageContext.host
            };
            dataLayer.push(obj);
            // If any of add to email list checkboxes is checked - Subscribed
            if ($("input[id^='add-to-email-list']:checked").length > 0) {
                emailSignup('Account Creation');
            }
        });
    }
};


/**
 *
 * @description Initialize the tag manager functionality
 * @param {string} nameSpace The current name space
 */
exports.init = function (nameSpace) {
    var ns = nameSpace || pageContext.ns;
    if (ns && events[ns]) {
        events[ns]();
    }
    events.all();
};

/**
 * @description Initialize Event for Category and Search pageload
 */
exports.category = function () {
    events.category();
};
